'use strict';

import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

class Header extends React.Component {
  constructor (props) {
    super(props);

    this.state = {
      sortKey: props.sortKey
    };
  }

  componentWillReceiveProps (nextProps) {
    if (this.state.sortKey !== nextProps.sortKey) {
      this.setState(nextProps);
    }
  }

  keysNotEquals (left, right) {
    const kLeft = left || '';
    const kRight = right || '';

    return kLeft.replace('-', '') !== kRight.replace('-', '');
  }

  getSortCondition (sortKey) {
    const key = this.state.sortKey;
    const validKey = sortKey && key;

    if (!validKey || this.keysNotEquals(sortKey, key)) {
      return '';
    }

    return key.charAt(0) === '-' ? ' \u2191' : ' \u2193';
  }

  getReversSortKey (sortKey) {
    const key = this.state.sortKey;

    if (this.keysNotEquals(sortKey, key)) {
      return sortKey;
    }

    return key.charAt(0) === '-' ? sortKey : '-' + sortKey;
  }

  renderGroup (data, index, headerList) {
    const attributes = data.getAttributes();
    const icon = data.getIcon();
    const labelList = data.getLabels();
    const labelCount = labelList.length;
    const labelElementList = [];
    const lastElement = index === (headerList.getHeaders().length - 2);
    let classNames = 'container';

    // рисуем иконку если есть
    if (icon) {
      labelElementList.push(
        <i key={index + '_ico'} className={icon} />
      );
    }

    if (lastElement) {
      classNames += ' last';
    }

    // рисуем лайблы если есть
    for (let i = 0; i < labelCount; i += 1) {
      const item = labelList[i];
      const props = this.props.disableSortHeader ? (
        !item.sortKey && {
          className: 'filler'
        }
      ) : ((
        item.sortKey && {
          className: 'sortable',
          onClick: this.props.onSort,
          'data-sortkey': this.getReversSortKey(item.sortKey)
        }) || (
        !item.sortKey && {
          className: 'filler'
        }));

      labelElementList.push(
        <span key={item.key} {...props}>
          {item.title + this.getSortCondition(item.sortKey)}
        </span>
      );

      if (i < (labelCount - 1)) {
        labelElementList.push(
          <span key={i + '_sep'}> / </span>
        );
      }
    }

    return <div key={index} className={classNames} {...attributes} >{ labelElementList }</div>;
  }

  render () {
    const { headerList } = this.props;
    if (headerList === null) {
      return null;
    }

    return (
      <Fragment>
        <div className='left-side'>
          {
            headerList
              .getHeaders().slice(0, 1)
              .map((item, index) => this.renderGroup(item, index, headerList))
          }
        </div>
        <div className='right-side'>
          {
            headerList
              .getHeaders().slice(1, headerList.getHeaders().length)
              .map((item, index) => this.renderGroup(item, index, headerList))
          }
        </div>
      </Fragment>
    );
  }
}

Header.propTypes = {
  headerList: PropTypes.object.isRequired,
  sortKey: PropTypes.string,
  onSort: PropTypes.func,
  disableSortHeader: PropTypes.bool
};

Header.defaultProps = {
  sortKey: '',
  onSort: () => null,
  disableSortHeader: false
};

export default Header;



// WEBPACK FOOTER //
// ./src/ui/FlexTable/Header.jsx